import API from "../../../helpers/API";
import { toastr } from "react-redux-toastr";
import { formatDateToYYYYMMDD } from "../../../helpers/Datetime";
import { showLoader, hideLoader } from "../../../common/actions/commonActions";
import {
    SET_ALL_LANGUAGES_LIST,
      } from "../../common/constants/ActionTypes";
import {
  LANGUAGE_ACTIVATE_DEACTIVATE,
     CREATE_LANGUAGE, GET_ALL_LANGUAGES_LIST, UPDATE_LANGUAGE
  } from "../../common/constants/endpoints";

  
export const getAllLanguagesList = () => {
    return async function (dispatch) {
      dispatch(showLoader());
      let response;
      let token = sessionStorage.getItem("token");
      try {
        response = await API.get(`${GET_ALL_LANGUAGES_LIST}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (response != null) {
          dispatch(hideLoader());
        }
        dispatch({
          type: SET_ALL_LANGUAGES_LIST,
          payload: response.data,
        });
      } catch (error) {
        dispatch(hideLoader());
        let errorMessage =
          error.response && error.response.data
            ? error.response.data.message
            : error.message;
        toastr.error(errorMessage);
        return;
      }
    };
  };
  

export const createLanguage = (requestBody={}, handleFormState, clearForm, page) => {
    return async function (dispatch) {
      dispatch(showLoader());
      let response;
      let token = sessionStorage.getItem("token");
      try {
        response = await API.post(`${CREATE_LANGUAGE}`,requestBody, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (response != null) {
          dispatch(hideLoader());
          window.scrollTo(0, 0)
          toastr.success(response.data.message);
          // handleFormState('list')
          // clearForm()
          dispatch(getAllLanguagesList(page, 10));
        //   dispatch(getFormTypeList());
        }
      } catch (error) {
        dispatch(hideLoader());
        let errorMessage =
          error.response && error.response.data
            ? error.response.data.message
            : error.message;
        toastr.error(errorMessage);
        return;
      }
    };
  };
  export const updateLanguage = (requestBody={}, handleFormState, clearForm, page) => {
    return async function (dispatch) {
      dispatch(showLoader());
      let response;
      const formData = new FormData();
      formData.append("id",requestBody.id)
      formData.append("name", requestBody.name);
      formData.append("description", requestBody.description);
      formData.append("isActive", requestBody.isActive);
      let token = sessionStorage.getItem("token");
      try {
        response = await API.patch(`${UPDATE_LANGUAGE}`,formData, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type':'multipart/form-data'
          },
        });
        if (response != null) {
          dispatch(hideLoader());
          window.scrollTo(0, 0)
          toastr.success("Language updated successfully.");
          handleFormState("list")
          clearForm()
          dispatch(getAllLanguagesList(page, 10));
        //   dispatch(getFormTypeList());
        }
      } catch (error) {
        dispatch(hideLoader());
        let errorMessage =
          error.response && error.response.data
            ? error.response.data.message
            : error.message;
        toastr.error(errorMessage);
        return;
      }
    };
  };

  
export const languageActivateDeactivate = (requestData, getAllLanguagesList, page) => {
  return async (dispatch) => {
      const session = JSON.parse(sessionStorage.getItem("session"));
      let tokent = sessionStorage.getItem("token");
      let response;
      try {
          response = await API.post(LANGUAGE_ACTIVATE_DEACTIVATE, requestData, {
              headers: { Authorization: `Bearer ${tokent}` },
          });
          dispatch(getAllLanguagesList(page,10))
          let successMessage = (response && response.data) ? response.data.message : response.message
          toastr.success(successMessage);
      } catch (error) {
        dispatch(getAllLanguagesList(page,10))

          let errorMessage = (error.response && error.response.data) ?
              error.response.data.message : error.message
          toastr.error(errorMessage);
          return;
      }
  }
}